import { IonButton, IonCheckbox, IonItem, IonLabel, IonList } from '@ionic/react';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getConfig } from '../../appConfig';
import { NormalText, Spacer, StrongText, Title } from '../../components/common';
import Layout from '../../components/layout';
import Mobiscroll from '../../components/mobiscroll';
import Loading from '../../components/spinner';
import Basket from '../../lib/basket';
import moment from '../../lib/moment';
import { withTranslation } from '../../lib/translate';
import { getOrderTypeMenus, goBack, isWebConfig } from '../../lib/utils';
import { getEffectiveAvailability, isStoreOpened } from '../clickAndCollect';
import { getCuratedMenu, getCuratedMenus } from '../../store/orders/actions';
import { getRestaurants } from '../../store/restaurants/actions';
import './index.css';

const { SelectOption } = Mobiscroll;

const getTimePickerOptions = (locations, restaurants, orderType) => {
	const now = moment().tz(getConfig().timezone);
	const { flag, getTimeSelector } = getOrderTypeMenus(orderType);
	const slots = new Set();
	locations.forEach((location) => {
		const restaurant = restaurants.find((restaurant) => restaurant.business_location_id == location.business_location_id);
		if (!restaurant || !restaurant.is_published || !restaurant[flag] || !Basket.isRestaurantAllowed(restaurant) || !isStoreOpened(restaurant)) return;
		const segments = getTimeSelector(restaurant)
			.filter((menu) => menu.menuId?.toString() === location.ikentooMenuId?.toString())
			.flatMap((menu) => getEffectiveAvailability(menu.availability, now.day()));
		segments.forEach(({ start, end }) => {
			const [startH, startM] = start.split(':').map((part) => parseInt(part));
			const [endH, endM] = end.split(':').map((part) => parseInt(part));
			const time = moment(now).hours(startH).minutes(startM).seconds(0);
			const closingTime = moment(now).hours(endH).minutes(endM).seconds(0);
			for (; time.isBefore(closingTime); time.add(15, 'minutes')) {
				if (time.isAfter(now)) {
					slots.add(time.format('HH:mm'));
				}
			}
		});
	});
	return [...slots].sort().map((slot) => ({ text: slot, value: slot }));
};

class CuratedMenus extends Component {
	constructor(props) {
		super(props);
		this.state = {
			selectedMenuId: null,
			showTime: false,
			pickTime: null,
		};
	}

	componentDidMount() {
		this.props.dispatch(getCuratedMenus());
		if (!this.props.restaurants?.length) {
			this.props.dispatch(getRestaurants());
		}
	}

	getMenuLocations = () => this.props.curatedMenus.find((menu) => menu.menuId === this.state.selectedMenuId)?.locations || [];

	getOrderType = () => this.props.location?.state?.orderType || Basket.getDeliveryOption()?.id || null;

	selectMenu = (menuId) => {
		const orderType = this.getOrderType();
		if (this.props.location?.state?.saveOrderData && Basket.has_multi_basket) {
			this.props.dispatch(getCuratedMenu(menuId, orderType, Basket.getASAP() ? null : Basket.getCollectionTime(), true));
		} else if (getOrderTypeMenus(orderType).asap) {
			this.props.dispatch(getCuratedMenu(menuId, orderType));
		} else {
			this.setState({ selectedMenuId: menuId, showTime: true, pickTime: null });
		}
	};

	setPickTime = (inst) => {
		this.setState({ pickTime: inst && inst.getVal() ? inst.getVal() : null });
	};

	backHandler = () => {
		if (this.state.showTime) {
			this.setState({ showTime: false, pickTime: null });
		} else {
			goBack();
		}
	};

	continueWithTime = () => {
		const { selectedMenuId, pickTime } = this.state;
		const orderType = this.getOrderType();
		const [h, m] = pickTime.split(':').map((part) => parseInt(part));
		this.props.dispatch(getCuratedMenu(selectedMenuId, orderType, moment().tz(getConfig().timezone).hours(h).minutes(m).seconds(0)));
	};

	drawTimePicker = (__) => {
		const { pickTime } = this.state;
		const timePickerOptions = getTimePickerOptions(this.getMenuLocations(), this.props.restaurants || [], this.getOrderType());
		return (
			<>
				<Title className="web-only page-title-centered">{__('Select a time')}</Title>
				<StrongText className="block text-to-update page-title-centered">{__('Select an available time for your order')}</StrongText>
				<Spacer size={2} />
				{timePickerOptions.length > 0 ? (
					<div className="time-picker-wrapper box-wrapper">
						<SelectOption
							cssClass={isWebConfig() ? 'web' : ''}
							theme="ios"
							wheels="3d"
							display="inline"
							onSet={(e, inst) => this.setPickTime(inst)}
							data={timePickerOptions}
							circular={false}
							value={pickTime}
							inputStyle="box"
							placeholder={__('Select time')}
							setText={__('OK')}
							cancelText={__('Cancel')}
							onInit={() => {
								if (!pickTime) {
									this.setState({ pickTime: timePickerOptions[0].value });
								}
							}}
						/>
					</div>
				) : (
					<div className="centered">
						<NormalText>{__('No available times')}</NormalText>
					</div>
				)}
				<Spacer size={5} />
				<IonButton disabled={!pickTime} expand="block" color="primary" className="button-uppercase" onClick={this.continueWithTime}>
					{__('Continue')}
				</IonButton>
			</>
		);
	};

	render() {
		const { __, curatedMenus } = this.props;
		const { selectedMenuId, showTime } = this.state;
		const tiledView = getConfig().general.tiledRestaurantView;

		return (
			<Loading>
				<Layout headerWithTitle={true} title={showTime ? __('Select a time') : __('Select a menu')} color="transparent" scrollY={false} backHandler={this.backHandler}>
					<div className={`${tiledView || showTime ? 'scrollable-y' : 'flex-row-wrapper'} absolute-content box-with-shadow`}>
						{showTime ? this.drawTimePicker(__) : (
						<>
						<Title className="web-only page-title-centered">{__('Select a menu')}</Title>
						<StrongText className="block text-to-update page-title-centered">{__('Select a menu to start your order')}</StrongText>
						<Spacer size={2} />
						<div className="order-locations-wrapper">
							<IonList className={tiledView ? 'tiled-box-wrapper' : 'box-wrapper'}>
								{curatedMenus.length > 0 ? (
									curatedMenus.map((menu) =>
										tiledView ? (
											<IonItem className="pointer box-wrapper" onClick={() => this.selectMenu(menu.menuId)} lines="none" key={menu.menuId}>
												<div style={{ width: '100%' }}>
													<img src={menu.menuImage} />
													<div>
														<StrongText className="text-to-update block">{__(menu.menuName)}</StrongText>
													</div>
												</div>
											</IonItem>
										) : (
											<IonItem onClick={() => this.setState({ selectedMenuId: menu.menuId })} lines="none" key={menu.menuId}>
												<IonLabel className="break-space">
													<StrongText className="block text-to-update">{__(menu.menuName)}</StrongText>
												</IonLabel>
												<IonCheckbox className="round-checkbox" checked={menu.menuId === selectedMenuId} slot="start" color="primary" />
											</IonItem>
										),
									)
								) : (
									<div className="centered">
										<NormalText>{__('No menus found')}</NormalText>
									</div>
								)}
							</IonList>
						</div>
						{!tiledView && (
							<>
								<Spacer size={5} />
								<IonButton
									disabled={selectedMenuId === null}
									expand="block"
									color="primary"
									className="button-uppercase"
									onClick={() => this.selectMenu(selectedMenuId)}
								>
									{__('Continue')}
								</IonButton>
							</>
						)}
						</>
						)}
					</div>
				</Layout>
			</Loading>
		);
	}
}

const stateToProps = (state) => ({
	curatedMenus: state.orders.curatedMenus,
	restaurants: state.restaurants.restaurants,
});

export default connect(stateToProps)(withTranslation(CuratedMenus));
